var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';







const PreserveIcon = ({ width = '24', height = '24', color }) => /*#__PURE__*/
_jsx("svg", {
  width: width,
  height: height,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg" }, void 0, /*#__PURE__*/

_jsx("path", {
  d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
  stroke: color || 'currentColor',
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
), /*#__PURE__*/
_jsx("path", {
  d: "M3 7V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H7",
  stroke: color || 'currentColor',
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
), /*#__PURE__*/
_jsx("path", {
  d: "M17 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V7",
  stroke: color || 'currentColor',
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
), /*#__PURE__*/
_jsx("path", {
  d: "M21 17V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H17",
  stroke: color || 'currentColor',
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
), /*#__PURE__*/
_jsx("path", {
  d: "M7 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V17",
  stroke: color || 'currentColor',
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round" }
)
);


export { PreserveIcon };